import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1l0 -2","key":"svg-0"}],["path",{"d":"M8 14a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-1"}],["path",{"d":"M19 7v7a7 7 0 0 1 -14 0v-7","key":"svg-2"}],["path",{"d":"M12 14l.01 0","key":"svg-3"}]]

const IconDeviceCctv = createReactComponent('outline', 'device-cctv', 'DeviceCctv', __iconNode);

export default IconDeviceCctv;